export default __webpack_public_path__ + "static/media/no-image-dark.96f86f74.svg";